var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-edit',{attrs:{"fields":_vm.isProvider ? _vm.adminFields : _vm.makerFields,"resourceName":_vm.resourceName,"pk":_vm.pk,"breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"images",fn:function(ref){
var input = ref.input;
return [_c('ImageList',{attrs:{"input":input,"resourceName":_vm.resourceName,"mode":"edit"},on:{"update:input":function($event){input=$event}}})]}},{key:"email",fn:function(ref){
var input = ref.input;
return [_c('div',[_vm._v(_vm._s(input))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }